module.exports = __webpack_public_path__ + "assets/img/00051.eb21adf4.png";